"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIFF_PAIR_SUFFIX_PATTERNS = exports.DiffPairPolarity = void 0;
exports.tryMatchDiffPairNames = tryMatchDiffPairNames;
var DiffPairPolarity;
(function (DiffPairPolarity) {
    DiffPairPolarity["Positive"] = "positive";
    DiffPairPolarity["Negative"] = "negative";
})(DiffPairPolarity || (exports.DiffPairPolarity = DiffPairPolarity = {}));
exports.DIFF_PAIR_SUFFIX_PATTERNS = [
    ['_pos', '_neg'],
    ['_p', '_n'],
    ['+', '-'],
    ['pos', 'neg'],
    ['p', 'n'],
];
function tryMatchDiffPairNames(name1, name2) {
    const lower1 = name1.toLowerCase();
    const lower2 = name2.toLowerCase();
    for (const [posSuffix, negSuffix] of exports.DIFF_PAIR_SUFFIX_PATTERNS) {
        if (lower1.endsWith(posSuffix) && lower2.endsWith(negSuffix)) {
            const base1 = lower1.slice(0, -posSuffix.length);
            const base2 = lower2.slice(0, -negSuffix.length);
            if (base1.length > 0 && base1 === base2) {
                return { base: base1, polarity1: DiffPairPolarity.Positive, polarity2: DiffPairPolarity.Negative };
            }
        }
        if (lower1.endsWith(negSuffix) && lower2.endsWith(posSuffix)) {
            const base1 = lower1.slice(0, -negSuffix.length);
            const base2 = lower2.slice(0, -posSuffix.length);
            if (base1.length > 0 && base1 === base2) {
                return { base: base1, polarity1: DiffPairPolarity.Negative, polarity2: DiffPairPolarity.Positive };
            }
        }
    }
    return null;
}
//# sourceMappingURL=diff-pair-names.js.map